import { render } from "./zdbeianList.vue?vue&type=template&id=524a400f&scoped=true"
import script from "./zdbeianList.vue?vue&type=script&lang=js"
export * from "./zdbeianList.vue?vue&type=script&lang=js"

import "./zdbeianList.vue?vue&type=style&index=0&id=524a400f&lang=scss&scoped=true"

import exportComponent from "/devops/jenkins_new/jenkins02-node1/workspace/Record_web_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-524a400f"]])

export default __exports__